import asiannightmarket from "./Images/asiannightmarket.png"

export const EventsData = [
  {
    image: asiannightmarket,
    title: "Asian Night Market",
    date: "January 31st, 2024",
    description:
      "We will be setting up a booth at the Asian Night Market! Swing by to eat some delicious Kyay Oh Si Chat, Kyauk Kyaw, and Shwe Yin Aye!",
  },
];
